module.exports = __webpack_public_path__ + "img/prizeBox.2a99be51.png";